"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require("redbox-react");

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require("react");

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require("react-transform-catch-errors");

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactRedux = require("react-redux");

var _reduxAsyncConnect = require("redux-async-connect");

var _reactRouterRedux = require("react-router-redux");

var _personal = require("redux/actions/personal");

var _payment = require("redux/actions/payment");

var _helpers = require("helpers");

var _config = require("config/config.pipo");

var _constants = require("redux/constants");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _operations = require("redux/actions/operations");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Operations: {
        displayName: "Operations"
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: "/usr/local/ibonus/src/containers/Personal/Operations/index.js",
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var MOMENT_DATE_FORMAT_SHOT = 'DD.MM.YYYY';
var MOMENT_DATE_FORMAT_ISO = 'YYYY-MM-DD[T]HH:mm:ss.SSSZZ';

var Operations = _wrapComponent("Operations")((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    promise: function promise(_ref) {
        var params = _ref.params,
            _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        return dispatch((0, _operations.getPipoOperations)((0, _moment2.default)().subtract(30, 'day').format('DD.MM.YYYY'), (0, _moment2.default)().format('DD.MM.YYYY')));
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        begDate: state.operations.begDate,
        count: state.operations.count,
        endDate: state.operations.endDate,
        items: state.operations.items,
        morePreload: state.operations.morePreload,
        multiBalans: state.operations.multiBalans,
        page: state.operations.page,
        preload: state.operations.preload,
        user: state.auth.user,
        lang: state.lang
    };
}, { push: _reactRouterRedux.push, getPipoOperations: _operations.getPipoOperations, morePipoOperations: _operations.morePipoOperations }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(Operations, _Component);

    function Operations(props) {
        (0, _classCallCheck3.default)(this, Operations);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Operations.__proto__ || (0, _getPrototypeOf2.default)(Operations)).call(this, props));

        _this.onChangeBeginDate = function (value, formattedValue) {
            _this.setState({
                begDate: formattedValue,
                begDateISO: value
            });
            //
            // const beginDateMoment = moment(formattedValue, MOMENT_DATE_FORMAT_SHOT);
            // const beginDateMomentPlus90 = moment(formattedValue, MOMENT_DATE_FORMAT_SHOT).add(90, 'days');
            // const endDateMoment = moment(this.state.endDate, MOMENT_DATE_FORMAT_SHOT);
            //
            // if (!endDateMoment.isBetween(beginDateMoment, beginDateMomentPlus90)) {
            //     this.setState({
            //         endDate: beginDateMomentPlus90.format(MOMENT_DATE_FORMAT_SHOT),
            //         endDateISO: beginDateMomentPlus90.format(MOMENT_DATE_FORMAT_ISO),
            //     });
            // }
        };

        _this.onChangeEndDate = function (value, formattedValue) {
            _this.setState({
                endDate: formattedValue,
                endDateISO: value
            });
            //
            // const endDateMoment = moment(formattedValue, MOMENT_DATE_FORMAT_SHOT);
            // const endDateMomentMinus90 = moment(formattedValue, MOMENT_DATE_FORMAT_SHOT).subtract(90, 'days');
            // const beginDateMoment = moment(this.state.begDate, MOMENT_DATE_FORMAT_SHOT);
            //
            // if (!beginDateMoment.isBetween(endDateMomentMinus90, endDateMoment)) {
            //     this.setState({
            //         begDate: endDateMomentMinus90.format(MOMENT_DATE_FORMAT_SHOT),
            //         begDateISO: endDateMomentMinus90.format(MOMENT_DATE_FORMAT_ISO),
            //     });
            // }
        };

        _this.handleSelect = function (e) {
            _this.setState({ activeSelect: e.target.value });
            var amount = e.target.value === 'all' ? -1 : e.target.value;
            _this.props.getPipoOperations(_this.state.begDate, _this.state.endDate, amount);
        };

        _this.onClick = function () {
            var amount = _this.state.activeSelect === 'all' ? -1 : _this.state.activeSelect;
            _this.props.getPipoOperations(_this.state.begDate, _this.state.endDate, amount);
        };

        _this.handleMoreClick = function (e) {
            var _this$props = _this.props,
                items = _this$props.items,
                page = _this$props.page;

            var amount = _this.state.activeSelect === 'all' ? -1 : _this.state.activeSelect;
            _this.props.morePipoOperations(_this.state.begDate, _this.state.endDate, amount, page + 1, _constants.OperationsNumericConstants.OPERATIONS_PAGE_LIMIT);
        };

        _this.state = {
            activeSelect: "all", // all или счёт пользователя
            begDate: _this.props.begDate,
            begDateISO: (0, _moment2.default)(_this.props.begDate, MOMENT_DATE_FORMAT_SHOT).format(MOMENT_DATE_FORMAT_ISO),
            endDate: _this.props.endDate,
            endDateISO: (0, _moment2.default)(_this.props.endDate, MOMENT_DATE_FORMAT_SHOT).format(MOMENT_DATE_FORMAT_ISO)
        };
        return _this;
    }

    (0, _createClass3.default)(Operations, [{
        key: "render",
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForContainer('Operations', null, { folderName: 'Personal/Operations' });
            var _state = this.state,
                begDateISO = _state.begDateISO,
                endDateISO = _state.endDateISO;
            var _props = this.props,
                count = _props.count,
                multiBalans = _props.multiBalans,
                morePreload = _props.morePreload,
                preload = _props.preload,
                user = _props.user,
                lang = _props.lang;


            if (user) {
                return _react3.default.createElement(View, {
                    activeSelect: this.state.activeSelect,
                    amount: user.amount,
                    balance: multiBalans,
                    begDate: begDateISO,
                    count: count,
                    endDate: endDateISO,
                    handleMoreClick: this.handleMoreClick,
                    handleSelect: this.handleSelect,
                    items: this.props.items,
                    morePreload: morePreload,
                    onChangeBeginDate: this.onChangeBeginDate,
                    onChangeEndDate: this.onChangeEndDate,
                    onClick: this.onClick,
                    preload: preload,
                    lang: lang
                });
            }

            return null;
        }
    }]);
    return Operations;
}(_react2.Component), _class2.propTypes = {
    begDate: _react2.PropTypes.any,
    count: _react2.PropTypes.any,
    endDate: _react2.PropTypes.any,
    item: _react2.PropTypes.array,
    items: _react2.PropTypes.any,
    morePreload: _react2.PropTypes.any,
    multiBalans: _react2.PropTypes.any,
    page: _react2.PropTypes.any,
    preload: _react2.PropTypes.any,
    user: _react2.PropTypes.object,
    lang: _react2.PropTypes.object
}, _class2.defaultProps = {
    item: []
}, _temp)) || _class) || _class));

exports.default = Operations;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Personal/Operations/index.js
// module id = 1828
// module chunks = 0